import {
  getApprovalsList,
  getApprovalsDetail,
  auditApprovals
} from '@/api/approvals'

const state = {}

const mutations = {}

const actions = {
  auditapprovals(context, params) {
    return auditApprovals(params)
  },
  getapprovalslist() {
    return getApprovalsList()
  },
  getapprovalsdetail(context, params) {
    return getApprovalsDetail(params)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
